/*
 *
 * VerifyOtp
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 23-Apr-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  cardTitle: <PortalMessage id='t.app.verifyOtp.cardTitle' defaultMessage='Conferma il tuo numero di telefono.' />,
  cardSubTitle: (phoneNumber) => (
    <PortalMessage
      id='t.app.verifyOtp.cardSubTitle'
      defaultMessage='Inserisci il <strong>codice</strong> che ti abbiamo inviato via SMS al numero <strong>{phoneNumber}</strong>.'
      values={{
        phoneNumber
      }}
    />
  ),
  labelLink: <PortalMessage id='t.app.verifyOtp.labelLink' defaultMessage='Invia un nuovo codice' />,
  requiredError: <PortalMessage id='t.app.error.requiredField' defaultMessage='Il campo è obbligatorio' />,
  continue: <PortalMessage id='t.app.continue' defaultMessage='Continua' />,
  invalidCode: <PortalMessage id='t.app.error.toast.wrongOtp' defaultMessage='Codice errato' />
}

export default formattedMessage
